import router from '../index'
import store from '../../store'
import {ROUTE_SWITCHING} from '../../store/mutation-types'

export default () => {
  router.afterEach((to, from) => {
    store.commit(ROUTE_SWITCHING, false)
  })
}



// WEBPACK FOOTER //
// ./src/router/setup/after.js